export enum CallbackStatusType {
    Waiting = 1
  , Error = 2
  , Completed = 3
  , CompletedAndClose = 4
}
